import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import ProdMachineTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import materialFlowsIcon from "../../../../../assets/new-product-detail-cats/sub-icons/surplus-material-flows.svg";
import surplusTreatment from "../../../../../assets/new-product-detail-cats/sub-icons/treatment-surplus-icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";

const ProdSurplusTreatment = ({ productId, systemBoundaryProps }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  return (
    <>
      <div className="prod-waste-contents">
        <SubHeaderBox
          subTitle={t("SURPLUS_RESOURCE_TREATMENT")}
          subDescription={t("SURPLUS_RESOURCE_TREATMENT_DESC")}
          number={"12.2E"}
          isNormal={true}
          systemBoundaryProps={systemBoundaryProps}
          showSystemBoundary={false}
          icon={surplusTreatment}
        />
        {shouldShowTable && (
          <TableLoadingWrapper
            tableId={`prod-surplustransport-${productId}`}
            minLoadTime={3000}
            maxLoadTime={20000}
          >
            <ProdMachineTable
              productId={productId}
              category={"Transport and product packaging from deliveries"}
            />{" "}
          </TableLoadingWrapper>
        )}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
      <div className="prod-waste-contents">
        <SubHeaderBox
          subTitle={t("SURPLUS_RESOURCE_MATERIAL_FLOWS")}
          number={"12.2F"}
          isNormal={true}
          systemBoundaryProps={systemBoundaryProps}
          showSystemBoundary={false}
          icon={materialFlowsIcon}
        />
        {shouldShowTable && (
          <TableLoadingWrapper
            tableId={`prod-surplusmaterial-${productId}`}
            minLoadTime={3000}
            maxLoadTime={20000}
          >
            <ProdMachineTable
              productId={productId}
              category={"Material flows during production"}
            />{" "}
          </TableLoadingWrapper>
        )}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
    </>
  );
};

export default ProdSurplusTreatment;
